import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Provider } from 'react-redux';
import { HotKeys } from 'react-hotkeys';
import store from './store';
import { FirebaseProvider } from './components/Firebase';
import { ConfirmationServiceProvider } from './components/Dialog/useConfirmation';
import { NotificationServiceProvider } from './components/Notification/useNotification';
import { UpgradeServiceProvider } from './components/Dialog/useUpgrade';

const keyMap = {
  REWIND_10: 'f1',
  PLAY_PAUSE: 'f2',
  JUMP_10: 'f3',
  SLOWER: 'f4',
  FASTE: 'f5'
};

ReactDOM.render(
  <Provider store={store}>
    <FirebaseProvider>
      <ConfirmationServiceProvider>
        <NotificationServiceProvider>
          <UpgradeServiceProvider>
            <CssBaseline />
            <HotKeys keyMap={keyMap} style={{ outline: 'none' }}>
              <App />
            </HotKeys>
          </UpgradeServiceProvider>
        </NotificationServiceProvider>
      </ConfirmationServiceProvider>
    </FirebaseProvider>
  </Provider>,
  document.getElementById('root')
);

console.log(`current environment: ${process.env.NODE_ENV}`);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
